import React from 'react';
import '../Layout.css';
import '../Top.css';
import Arrow from './Arrow';
/* eslint-disable import/no-webpack-loader-syntax */
import IntroductionStatement from "!babel-loader!@mdx-js/loader!../Article/IntroductionStatement.mdx"


export default class Introduction extends React.Component {
    render() {
        return (
            <div className="introduction">
                <header>
                    <article className="articleIntroduction">
                        <h1 className="siteNameHeading">{this.props.siteName}</h1>
                        <section className="articleTopText articleText">
                            <IntroductionStatement />
                        </section>
                    </article>
                </header>
                <Arrow />
            </div>
        )
    }
}